import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { Modal } from '@atoms';
import { Control, UseFormHandleSubmit } from 'react-hook-form';
import AddSentimentAnalysisModalForm from './AddSentimentAnalysisModalForm';
import {
  FeedbackItem,
  SENTIMENT_ANALYSIS_OPTION,
  SENTIMENT_ANALYSIS_SUBCATEGORIES,
} from 'src/features/Enterprise/SentimentAnalysis/types';

interface MainModalProps {
  isEdit: boolean;
  open: boolean;
  isValid: boolean;
  isLoading: boolean;
  control: Control<FeedbackItem, any>;
  handleSubmit: UseFormHandleSubmit<FeedbackItem>;
  onClose: () => void;
  onFinalSubmit: (data: FeedbackItem) => void;
  title: string;
  subtitle: string;
  categories: SENTIMENT_ANALYSIS_OPTION[];
  subCategories: SENTIMENT_ANALYSIS_SUBCATEGORIES[];
}

const MainModal: React.FC<MainModalProps> = ({
  isEdit,
  open,
  isValid,
  isLoading,
  control,
  handleSubmit,
  onClose,
  onFinalSubmit,
  title,
  subtitle,
  categories,
  subCategories,
}) => {
  return (
    <Modal title={title} open={open} onClose={onClose}>
      <Box
        component="form"
        display="flex"
        flexDirection="column"
        onSubmit={handleSubmit(onFinalSubmit)}
      >
        <Typography variant="body2" mt="8px" color="text.secondary" mb="40px">
          {subtitle}
        </Typography>

        <AddSentimentAnalysisModalForm
          control={control}
          categories={categories}
          subCategories={subCategories}
        />

        <Box display="flex" justifyContent="flex-end">
          <Button color="secondary" onClick={onClose}>
            Cancel
          </Button>
          <LoadingButton variant="contained" type="submit" disabled={!isValid} loading={isLoading}>
            {isEdit ? 'Update' : 'Create'}
          </LoadingButton>
        </Box>
      </Box>
    </Modal>
  );
};

export default MainModal;
